/**
 * @fileoverview POST handler for the "/engagement/query_builder/:report_id/:app_group_id/export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementQueryBuilderReportIdAppGroupIdExportCacheKeys } from "./constants";
import type {
  EngagementQueryBuilderReportIdAppGroupIdExportResult,
  PostEngagementQueryBuilderReportIdAppGroupIdExportProps,
} from "./types";

export const postEngagementQueryBuilderReportIdAppGroupIdExport = reactQueryMutationAdapter(
  engagementQueryBuilderReportIdAppGroupIdExportCacheKeys,
  (
    props: PostEngagementQueryBuilderReportIdAppGroupIdExportProps
  ): Promise<EngagementQueryBuilderReportIdAppGroupIdExportResult> => {
    return fetch(
      `/engagement/query_builder/${props.reportId}/${props.appGroupId}/export`,
      "POST",
      props,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
